import React from 'react'
import type { ListItemProps as MuiListItemProps } from '@material-ui/core/ListItem'
import MuiListItem from '@material-ui/core/ListItem'

export type ListItemProps = MuiListItemProps

function ListItem(props: ListItemProps) {
  return <MuiListItem {...(props as any)} />
}

export default ListItem
